// src/pages/EmployerJobs.js

import React, { useEffect, useState } from "react";
import $ from "jquery";
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import { format } from "date-fns";

import api from "../../../api/axios";
import jbAPI from "../../../api/jobboard";
import JobForm from "../../../components/employer/JobForm";

import { getApplicantsByCompany, getApplicantJobs  } from "../../../api/ApplicantsAPI";


const ViewApplications = () => {
  const location = useLocation();
  const [jobs, setJobs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editJobData, setEditJobData] = useState(null);
  const [message, setMessage] = useState({ type: "", text: "" });
  const navigate = useNavigate();
  const token = localStorage.getItem("otoken");
  const companyId = localStorage.getItem("companyId"); 
  const [applicants, setApplicants] = useState([]);
  useEffect(() => {
     const timer = setTimeout(() => {
      $('#jobListTable').DataTable();
    }, 1000); // wait for DOM to render

   
  
    const fetchApplicants = async () => {
        const data = await getApplicantsByCompany(companyId, token);
        setApplicants(data);
      };

      if (companyId && token) {
        fetchApplicants();
      }
    }, [companyId, token]);

      const [selectedApplicantJobs, setSelectedApplicantJobs] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleViewJobs = async (seekerId) => {
    setLoading(true);

    const data = await getApplicantJobs(companyId, seekerId, token);

    setSelectedApplicantJobs(data);
    setLoading(false);
  };

  

  return (
    <div className="content-body">
      <div className="container-fluid mt-3">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    {message.text && (
                      <div
                        className={`alert alert-${message.type} mt-3`}
                        role="alert"
                      >
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                          onClick={() => setMessage({ text: "", type: "" })}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                        {message.text}
                      </div>
                    )}
                    <div className="d-flex justify-content-between ">
                      <h4 className="card-title mb-0">Applicants Lists</h4>
                      {/* <button
                        className="btn btn-lg btn-outline-primary"
                        title="New Job Post"
                        onClick={() => navigate("/employer/job-management/new")}
                      >
                        <i className="fa fa-plus-circle"></i>
                      </button> */}
                    </div>
    
                    <div className="table-responsive mt-2">
                      <table id="jobListTable" className="table table-striped table-bordered mt-2">
                        <thead className="text-center">
                          <tr>
                            <th>Applicant Name</th>
                            <th>Email ID</th>
                            <th>Mobile # </th>
                            <th>No. of Jobs Applied</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {applicants.map((item) => (
                            <tr key={item.applicant.seeker_id}>
                              <td>{item.applicant.name}</td>
                              <td>{item.applicant.email}</td>
                              <td>{item.applicant.mobile}</td>
                              <td>{Number(item.applicant.job_count)}</td>                             
                              <td>
                                {/* <button
                                  className="btn btn-sm btn-outline-primary me-1 mr-2"
                                  title="Edit"
                                  onClick={() =>
                                    navigate(
                                      `/employer/job-management/edit/${item.applicant.seeker_id}`
                                    )
                                  }
                                >
                                  <i className="fa fa-pencil-square"></i>
                                </button> */}
                                {/* <button
                                  className="btn btn-sm btn-outline-warning me-1 mr-2"
                                  title="Deactivate"
                                  // onClick={() => handleToggleStatus(item.applicant.seeker_id)}
                                >
                                  <i className="fa fa-remove"></i>
                                </button> */}
                                <button
                                  className="btn btn-sm btn-outline-info me-1 mr-2"
                                  title="View Jobs"
                                   onClick={() =>
                                    navigate(
                                      `/employer/view-applicant/jobs/${item.applicant.seeker_id}`
                                    )
                                  }                                
                                >
                                  <i className="fa fa-eye"></i>
                                </button>
                                {/* <button
                                  className="btn btn-sm btn-outline-danger me-1 mr-2"
                                  title="Delete"
                                  // onClick={() => handleDelete(item.applicant.seeker_id)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button> */}
                                {/* <button
                                  className="btn btn-sm btn-outline-secondary"
                                  title="Copy Job Post"
                                  // onClick={() => handleCopyJob(job)}
                                >
                                  <i className="fa fa-copy"></i>
                                </button> */}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      </div>
    </div>
  );
};

export default ViewApplications;
